import React from "react";

export type EstateTypeParentNodeProps = {
    headerLineText: string,
};

const EstateTypeParentNode = ({data}: { data: EstateTypeParentNodeProps }) => {
    return (
        <div className={"first-level-node"}>
            <div className={"estate-type-header"}>
                <hr/>
                <span>{data.headerLineText}</span>
                <hr/>
            </div>
        </div>
    );
}

export default EstateTypeParentNode;